import { CeresFeaturesConfig } from './interfaces/ceres-features-config.interface';

const FEATURES: CeresFeaturesConfig = {
    timeManagement: {
        enabled: true,
        timeSheets: true,
        transactionalTimeTracking: true,
        capacity: true,
        absences: true,
        workload: true,
        disableTimeSheetsOption: true
    },
    businessPartner: {
        enabled: true
    },
    sales: {
        enabled: true,
        businessOpportunities: true,
        salesActivities: true,
        salesFunnel: true,
        offers: true,
        offersV2: true
    },
    projects: {
        enabled: true,
        copyExistingProject: true,
        copyExistingProjectWithChildren: true,
        orcChecker: true,
        inheritance: true,
        groups: {
            enabled: true,
            statusReports: true,
            classification: true
        },
        charging: true,
        timesheetLock: true,
        chargingCopyProposalBillingValue: true,
        nrsView: true,
        preStaffing: true,
        projectValueInheritance: true,
        restrictTimesheetFavoritesToAssignedProjects: false,
        projectSharedCosts: true
    },
    reporting: {
        enabled: true,
        dataQuality: true,
        pulseDashboard: true,
        costReport: true,
        workingHoursReport: true,
        absenceReport: true,
        gmsReportingDemo: true,
        productivityReport: true
    },
    employees: {
        enabled: true,
        experiences: true,
        multiRole: true
    },
    faq: {
        enabled: true
    },
    ticketTool: {
        enabled: true
    },
    administration: {
        enabled: true,
        servicePackages: true,
        departments: true,
        serviceProducts: true,
        orgIds: true,
        experiences: true,
        juno: true,
        customerPspElements: true,
        globalNotifications: true
    },
    services: {
        enabled: true,
        documents: true
    },
    scheduling: {
        enabled: true,
        scheduler: true,
        analytics: true,
        unrestrictedAccess: true
    },
    global: {
        currencyConversion: true,
        darkMode: true,
        sharepoint: true,
        auditTrail: true,
        auditTrailSubscriptions: true
    },
    sharepointExport: {
        enabled: true
    },
    pocReminder: {
        enabled: true
    },
    projectConfirmation: {
        enabled: true
    },
    documentCategorization: {
        enabled: true
    }
};

export default FEATURES;
